import { ApiRoutes } from '../helpers/routes'
import { TRegisterFullInfo, TRegisterInfo } from '../hooks/useFormRegister'
import { getDocumentType, RegisterInfoDTO } from '../models/auth'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/auth`

class AuthService {
    login = async (email: string, password: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.auth.login}`, {
            method: 'POST',
            body: JSON.stringify({ email, password }),
        })
    }

    logout = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.auth.logout}`, {
            method: 'POST',
        })
    }

    verifyExistence = async (info: TRegisterInfo) => {
        const params = new URLSearchParams({
            email: info.email,
            documentType: getDocumentType(info.documentType),
            documentValue: info.documentValue,
        })
        return fetchApi(`${baseUrl}${ApiRoutes.auth.verifyExistence}?${params.toString()}`, {
            method: 'GET',
        })
    }

    registerUser = async (info: TRegisterFullInfo) => {
        return fetchApi(`${baseUrl}`, {
            method: 'POST',
            body: JSON.stringify(new RegisterInfoDTO(info)),
        })
    }

    registerPendingUser = async (info: TRegisterFullInfo) => {
        return fetchApi(`${baseUrl}${ApiRoutes.auth.registerPendingUser}`, {
            method: 'POST',
            body: JSON.stringify(info),
        })
    }
}

export default AuthService
